import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Icon, NamedLink } from '../../components';
import Autosuggest from 'react-autosuggest';

import css from './SearchArticles.module.css';

const getSuggestions = (value, options) => {
  const inputValue = value.trim().toLowerCase();
  const inputLength = inputValue.length;

  return inputLength === 0
    ? []
    : options
        .filter(lang => {
          return lang.label.toLowerCase().indexOf(inputValue) !== -1;
        })
        .slice(0, 10);
};

const getSuggestionValue = suggestion => suggestion.label;

const renderSuggestion = suggestion => {
  const topicId = suggestion.topic;
  const articleId = suggestion.key;
  return (
    <NamedLink
      name="ArticlePage"
      params={{ topicId, articleId }}
      className={css.autoSuggestSuggestionsListItemLink}
    >
      {suggestion.label}
    </NamedLink>
  );
};

const SearchArticles = props => {
  const [value, setValue] = useState('');
  const [suggestions, setSuggestions] = useState([]);

  const { intl, options } = props;

  const onChange = (event, { newValue }) => {
    setValue(newValue);
  };

  const onSuggestionsFetchRequested = ({ value }) => {
    setSuggestions(getSuggestions(value, options));
  };

  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  const inputProps = {
    placeholder: intl.formatMessage({
      id: 'HelpPage.searchPlaceholder',
    }),
    value,
    onChange,
  };

  return (
    <div className={css.search}>
      <Icon name="search" size={18} className={css.searchIcon} />
      <Autosuggest
        id="HelpPage.searchArticles"
        className={css.autoSuggest}
        suggestions={suggestions}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        inputProps={inputProps}
        theme={{
          container: css.autoSuggestContainer,
          input: css.autoSuggestInput,
          suggestionsContainer: css.autoSuggestSuggestionsContainer,
          suggestionsContainerOpen: css.autoSuggestSuggestionsContainerOpen,
          suggestionsList: css.autoSuggestSuggestionsList,
          suggestion: css.autoSuggestSuggestionsListItem,
          suggestionHighlighted: 'react_autosuggest__suggestion__highlighted',
        }}
      />
    </div>
  );
};

export default withRouter(SearchArticles);
